import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FC,
  Fragment,
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
} from "react";

export type InputWithIconInformationprops =
  InputHTMLAttributes<HTMLInputElement> & {
    label: string;
    span?: string;
    error?: boolean;
    textDescribe?: string;
    textInformation?: string;
  };

export const InputWithIconInformation: FC<InputWithIconInformationprops> = ({
  label,
  span,
  error,
  textDescribe,
  textInformation,
  ...props
}) => {
  // Estado para controlar la visibilidad del tooltip
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  // Referencia al contenedor del tooltip
  const tooltipRef = useRef<HTMLDivElement>(null);

  // Función para manejar clics fuera del tooltip
  const handleClickOutside = (event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setIsTooltipVisible(false);
    }
  };

  // Agregar y limpiar el listener de clics fuera del componente
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Fragment>
      <div className="relative">
        <div className="flex items-center justify-between">
          {/* Label e ícono */}
          <div className="flex items-center">
            <label
              htmlFor={props.id}
              className="block text-sm font-medium leading-6 text-gray-600"
            >
              {label}
            </label>

            {/* Contenedor del ícono de información */}
            <div className="relative ml-2">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="text-gray-500 cursor-pointer"
                onClick={() => setIsTooltipVisible(!isTooltipVisible)}
              />

              {/* Tooltip que aparece solo al hacer clic en el ícono */}
              {isTooltipVisible && (
                <div
                  ref={tooltipRef}
                  className={`absolute left-0 top-full mt-1 w-40 p-2 text-gray-500 bg-white text-xs rounded-md shadow-lg transition-opacity opacity-100`}
                >
                  {textInformation}
                </div>
              )}
            </div>
          </div>

          {/* Span adicional */}
          <span
            aria-describedby={props.id}
            className={`text-sm leading-6 ${
              error ? "text-red-600" : "text-gray-500"
            }`}
          >
            {span}
          </span>
        </div>

        {/* Input */}
        <div className="">
          <input
            {...props}
            className={`px-2 block w-full rounded-md border-0 py-1.5 text-gray-500 shadow-sm ring-1 ring-inset ${
              error
                ? "ring-red-600 placeholder:text-red-400"
                : "ring-gray-300 placeholder:text-gray-400"
            } focus:ring-2 focus:ring-inset ${
              error ? "focus:ring-red-600" : "focus:ring-indigo-600"
            } sm:text-sm sm:leading-6`}
          />
        </div>

        {/* Descripción del campo debajo */}
        <p className="mt-1 text-sm text-gray-400">{textDescribe}</p>
      </div>
    </Fragment>
  );
};
